import { IThemePack } from '../shared/interfaces/IThemePack';

export function loadThemePacks(themePacks: Record<string, IThemePack>) {
  // Extract Vuetify Defaults and Theme configs
  const themes = Object.values(themePacks).reduce((prev, current) => ({ ...prev, [current.name]: current.vuetify.theme }), {});
  const defaults = Object.values(themePacks).map((themePack) => themePack.vuetify.defaults);

  return { themes, defaults };
}
